import { z } from 'zod';

export const sessionInfoSchema = z.object({
  /**
   * Legacy ID that represents a session - use `sessionId` instead.
   * @deprecated
   */
  visitId: z.string().uuid(),
  /** An ID used to represent a temporary session which is reset after N minutes of inactivity */
  sessionId: z.string().uuid(),
  /** Timestamp of when the session started */
  startTimestamp: z.number(),
});
